import React from 'react';
import KbRequestsReportsApp from '@atlassian/jira-servicedesk-kb-requests-reports/src/index.tsx';
import { toBaseUrl, toProjectKey, toProjectId } from '@atlassian/jira-shared-types/src/general.tsx';
import useReportsRouter from '@atlassian/jira-spa-apps-servicedesk-reports-base/src/ui/use-reports-router/index.tsx';
import type { Props } from './types.tsx';

const KbRequestsReportsSpa = ({ pageContext }: Props) => {
	const { projectKey, projectId, projectName } = pageContext;
	const routerProps = useReportsRouter();
	return (
		<KbRequestsReportsApp
			baseUrl={toBaseUrl('')}
			projectKey={toProjectKey(projectKey)}
			projectId={toProjectId(String(projectId))}
			routerProps={routerProps}
			projectName={projectName}
		/>
	);
};

export default KbRequestsReportsSpa;
